import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { styles } from './styles';

export const GuestInfoDrawerSkeleton: FC = () => {
  return (
    <div {...stylex.props(styles.drawerContent)}>
      {/* Основной гость */}
      <div {...stylex.props(styles.infoGroup)}>
        <div {...stylex.props(styles.titleBlock)}>
          <div {...stylex.props(styles.skeleton, styles.skeletonName)} />
          <div {...stylex.props(styles.skeleton, styles.skeletonBadge)} />
        </div>
        <div {...stylex.props(styles.infoTable)}>
          {new Array(5).fill(0).map((_, index) => (
            <div key={index} {...stylex.props(styles.dataRow)}>
              <div {...stylex.props(styles.labelContainer)}>
                <div {...stylex.props(styles.skeleton, styles.skeletonLabel)} />
                <div {...stylex.props(styles.dottedLine)} />
              </div>
              <div {...stylex.props(styles.skeleton, styles.skeletonValue)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
